const MESSAGE = 'This user is not authorised.';

export class UnauthorisedError extends Error {
  constructor() {
    super(MESSAGE);
  }
}
